//I've decided to do this page NOT by venue, but just a long list
import React, { useState, useEffect, useContext } from 'react'
import './FullSchedule.css'
import './FullScheduleCards.css'
import { useParams, NavLink } from 'react-router-dom'
import { AuthContext } from '../context/auth-context'
import Footer from '../components/UIElements/Footer'
import LoadingSpinner from '../components/UIElements/LoadingSpinner'
import SchedulesHomeNavigation from '../components/Navigation/SchedulesHomeNavigation'
import SearchByLeagueOrVenue from '../components/UIElements/SearchByLeagueOrVenue'
import brookline from '../../images/brookline.png'
import cranberry from '../../images/cranberry.PNG'
import falcons from '../../images/falcons.png'
import latrobe from '../../images/latrobe.PNG'
import mckeesport from '../../images/mckeesport.PNG'
import murrysville from '../../images/murrysville.png'
import newKen from '../../images/newKen.png'
import pennHills from '../../images/pennHills.PNG'
import riverview from '../../images/riverview.PNG'
import southHills from '../../images/southHills.png'
import teamPitt from '../../images/teamPitt.png'
import venom from '../../images/venom.png'
import bridgeville from '../../images/bridgeville.PNG'
import eggHarbor from '../../images/eggHarbor.PNG'
import gtha from '../../images/gtha.png'
import leominster from '../../images/leominster.png'
import mapleShade from '../../images/mapleShade.PNG'
import marlton from '../../images/marlton.PNG'
import maysLanding from '../../images/maysLanding.PNG'
import medfordRenegades from '../../images/medfordRenegades.PNG'
import nymenace from '../../images/nymenace.png'
import scottTownship from '../../images/scottTownship.PNG'
import westDeptford from '../../images/westDeptford.PNG'
import bellmawr from '../../images/bellmawr.PNG'
import athol from '../../images/athol.PNG'
import monroe from '../../images/monroe.PNG'
import fitchburg from '../../images/fitchburg.PNG'
import pa from '../../images/PA.png'
import tricounty from '../../images/tri_county.png'

const VenueSchedule = () => {
	console.log('inside VenueSchedule')

	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [allVenueGamesAndEvents, setAllVenueGamesAndEvents] = useState([])
	const [isMobile, setIsMobile] = useState(false)

	const auth = useContext(AuthContext)
	const venueId = useParams().venueId

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 440)
		}

		handleResize()

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			setAllVenueGamesAndEvents([])

			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/${venueId}/schedule`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setAllVenueGamesAndEvents(responseData.allVenueGamesAndEventsArray)
			} catch (err) {
				setError(err.message)
			}

			setIsLoading(false)
		}

		sendRequest()
	}, [venueId])

	const errorHandler = () => {
		setError(null)
	}

	if (isLoading) {
		return (
			<div className='center' style={{ marginTop: '10rem' }}>
				<LoadingSpinner />
			</div>
		)
	}

	const getFormattedDate = (game) => {
		const month = game.date.substr(0, 2)
		const day = game.date.substr(3, 2)

		const monthMap = {
			'01': 'Jan.',
			'02': 'Feb.',
			'03': 'Mar.',
			'04': 'Apr.',
			'05': 'May',
			'06': 'June',
			'07': 'July',
			'08': 'Aug.',
			'09': 'Sept.',
			10: 'Oct.',
			11: 'Nov.',
			12: 'Dec.',
		}

		return `${game.dayOfWeek}, ${monthMap[month]} ${day}`
	}

	const getFormattedTime = (game) => {
		const hour = game.time.substr(0, 2)
		const minutes = game.time.substr(3, 2)

		const hourMap = {
			'00': '12',
			'01': '1',
			'02': '2',
			'03': '3',
			'04': '4',
			'05': '5',
			'06': '6',
			'07': '7',
			'08': '8',
			'09': '9',
			10: '10',
			11: '11',
			12: '12',
			13: '1',
			14: '2',
			15: '3',
			16: '4',
			17: '5',
			18: '6',
			19: '7',
			20: '8',
			21: '9',
			22: '10',
			23: '11',
			24: '12',
		}

		const suffix = Number(hour) < 12 || hour === '24' ? 'AM' : 'PM'

		return `${hourMap[hour]}:${minutes} ${suffix}`
	}

	const getMobileScore = (game) => {
		if (!game.score) return ''

		const scoreParts = game.score.split('-').map((score) => score.trim())
		let scoreOnly = game.score

		if (scoreParts.length === 2) {
			const firstScore = scoreParts[0]
			const secondScore = scoreParts[1]

			if (game.winner === game.visitorTeamId) {
				scoreOnly = `${secondScore} - ${firstScore}`
			} else {
				scoreOnly = `${firstScore} - ${secondScore}`
			}
		}

		if (game.OTLHomeIsChecked || game.OTLVisitorIsChecked) {
			scoreOnly += ' (OT)'
		}

		return scoreOnly
	}

	const getWinningTeamClass = (game, team) => {
		if (!game.score) return ''

		const isWinner =
			(team === 'home' && game.winner === game.homeTeamId) ||
			(team === 'visitor' && game.winner === game.visitorTeamId)

		if (!isWinner) return ''

		const isPlayoff = game.playoff || game.championship || game.description

		return isPlayoff
			? 'mobileWinningTeam mobileWinningTeamPlayoff'
			: 'mobileWinningTeam'
	}

	const getTeamLogo = (teamName) => {
		if (!teamName) return null

		if (teamName.includes('Brookline')) return brookline
		if (teamName.includes('Cranberry')) return cranberry
		if (teamName.includes('Falcons')) return falcons
		if (teamName.includes('Bill')) return falcons
		if (teamName.includes('Latrobe')) return latrobe
		if (teamName.includes('McKeesport')) return mckeesport
		if (teamName.includes('Murrysville')) return murrysville
		if (teamName.includes('MDH')) return murrysville
		if (teamName.includes('New Ken')) return newKen
		if (teamName.includes('Penn Hills')) return pennHills
		if (teamName.includes('Arsenal')) return pennHills
		if (teamName.includes('Riverview')) return riverview
		if (teamName.includes('South Hills')) return southHills
		if (teamName.includes('South Pgh')) return southHills
		if (teamName.includes('South Pittsburgh')) return southHills
		if (teamName.includes('Team Pitt')) return teamPitt
		if (teamName.includes('Venom')) return venom
		if (teamName.includes('Bridgeville')) return bridgeville
		if (teamName.includes('Egg Harbor')) return eggHarbor
		if (teamName.includes('GTHA')) return gtha
		if (teamName.includes('Leominster')) return leominster
		if (teamName.includes('Maple Shade')) return mapleShade
		if (teamName.includes('Marlton')) return marlton
		if (teamName.includes('Mays Landing')) return maysLanding
		if (teamName.includes('Medford')) return medfordRenegades
		if (teamName.includes('NY Menace')) return nymenace
		if (teamName.includes('Menace')) return nymenace
		if (teamName.includes('Scott')) return scottTownship
		if (teamName.includes('Dekhounds')) return scottTownship
		if (teamName.includes('West Deptford')) return westDeptford
		if (teamName.includes('Bellmawr')) return bellmawr
		if (teamName.includes('Athol')) return athol
		if (teamName.includes('Monroe')) return monroe
		if (teamName.includes('Fitchburg')) return fitchburg
		if (teamName.includes('Raptors')) return riverview
		if (teamName.includes('Screaming')) return cranberry
		if (teamName.includes('Vipers')) return bridgeville
		if (teamName.includes('Vikings')) return southHills
		if (teamName.includes('Barbarians')) return southHills
		if (teamName.includes('Raiders')) return southHills
		if (teamName.includes('Gods')) return teamPitt
		if (teamName.includes('Eagles')) return cranberry
		if (teamName.includes('Team PA')) return pa
		if (teamName.includes('Tri County')) return tricounty
		if (teamName.includes('Tri-County')) return tricounty

		return null
	}

	const getAdminButton = (game) => {
		if (!auth.isLoggedIn) return null

		if (
			game.playoff &&
			game.homeTeamName &&
			game.homeTeamName !== 'TBD' &&
			game.visitorTeamName !== 'TBD'
		) {
			return (
				<NavLink
					className='mobileGameAdminButton'
					to={`/admin/playoffGameResults/${game._id}`}
					exact
				>
					Results
				</NavLink>
			)
		}

		if (
			game.championship &&
			game.homeTeamName &&
			game.homeTeamName !== 'TBD' &&
			game.visitorTeamName !== 'TBD'
		) {
			return (
				<NavLink
					className='mobileGameAdminButton'
					to={`/admin/championshipGameResults/${game._id}`}
					exact
				>
					Results
				</NavLink>
			)
		}

		if (
			!game.playoff &&
			!game.championship &&
			game.homeTeamName &&
			game.homeTeamName !== 'TBD' &&
			game.visitorTeamName !== 'TBD'
		) {
			return (
				<NavLink
					className='mobileGameAdminButton'
					to={`/admin/gameResults/${game._id}`}
					exact
				>
					Results
				</NavLink>
			)
		}

		if (
			game.playoff &&
			!game.championship &&
			game.homeTeamName &&
			(game.homeTeamName === 'TBD' || game.visitorTeamName === 'TBD')
		) {
			return (
				<NavLink
					className='mobileGameAdminButton'
					to={`/admin/updateGame/${game._id}`}
					exact
				>
					Teams
				</NavLink>
			)
		}

		return null
	}

	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth',
		})

		document.documentElement.scrollTop = 0
		document.body.scrollTop = 0
	}

	const renderMobileScheduleCards = (games = []) => {
		return (
			<div className='mobileGameCards'>
				{games.map((game, key) => {
					const isPlayoffStyle =
						game.playoff || game.championship || game.description

					const homeLogo = getTeamLogo(game.homeTeamName)
					const visitorLogo = getTeamLogo(game.visitorTeamName)

					const divisionLabel = game.playoff
						? game.playoffDivision
						: game.divisionName

					const adminButton = getAdminButton(game)

					return (
						<div
							className={`mobileGameCard ${
								isPlayoffStyle ? 'mobileGameCardPlayoff' : ''
							}`}
							key={game._id || key}
						>
							<div className='mobileGameCardHeader'>
								<div>{getFormattedDate(game)}</div>

								<div className='mobileGameDivisionHeader'>
									<span>{divisionLabel}</span>

									{game.description && (
										<span className='mobileGameDescription'>
											{game.description}
										</span>
									)}

									{game.championship && !game.description && (
										<span className='mobileGameDescription'>
											Championship Game
										</span>
									)}
								</div>

								<div>{getFormattedTime(game)}</div>
							</div>

							{game.eventName ? (
								<div className='mobileGameCardBody'>
									<div className='mobileGameTeam'>
										<div>{game.eventName}</div>
									</div>
								</div>
							) : (
								<div className='mobileGameCardBody'>
									<div className='mobileGameTeam'>
										{homeLogo && (
											<img
												className='mobileGameTeamLogo'
												src={homeLogo}
												alt={game.homeTeamName}
											/>
										)}

										<div className={getWinningTeamClass(game, 'home')}>
											{game.homeTeamSeed > 0 && `(${game.homeTeamSeed}) `}
											{game.homeTeamName}
											{game.noPointsForHomeTeam && ' (NP)'}
										</div>
									</div>

									{game.score ? (
										<div className='mobileGameScore'>
											{getMobileScore(game)}
											<span>Final</span>
										</div>
									) : (
										<div className='mobileGameScore mobileGameScoreEmpty'>
											<span>TBP</span>
										</div>
									)}

									<div className='mobileGameTeam'>
										{visitorLogo && (
											<img
												className='mobileGameTeamLogo'
												src={visitorLogo}
												alt={game.visitorTeamName}
											/>
										)}

										<div className={getWinningTeamClass(game, 'visitor')}>
											{game.visitorTeamSeed > 0 && `(${game.visitorTeamSeed}) `}
											{game.visitorTeamName}
											{game.noPointsForVisitorTeam && ' (NP)'}
										</div>
									</div>
								</div>
							)}

							{adminButton && (
								<div className='mobileGameVenue'>
									<div className='mobileGameAdminActions'>{adminButton}</div>
								</div>
							)}
						</div>
					)
				})}
			</div>
		)
	}

	let dateBlock
	dateBlock = []

	if (!isLoading && allVenueGamesAndEvents.length === 0) {
		return (
			<React.Fragment>
				<SchedulesHomeNavigation />
				<SearchByLeagueOrVenue />
				<div className='Leagues'>
					<h1>NOTHING SCHEDULED YET!</h1>
				</div>
				<div style={{ marginTop: '16rem' }}>
					<Footer />
				</div>
			</React.Fragment>
		)
	}

	if (!isLoading && allVenueGamesAndEvents.length !== 0) {
		dateBlock.push(
			<div className='Schedule' key='venue-schedule'>
				<h4 style={{ textAlign: 'center', fontWeight: '600' }}>
					{allVenueGamesAndEvents[0].venueName}
				</h4>

				{isMobile ? (
					renderMobileScheduleCards(allVenueGamesAndEvents)
				) : (
					<table id='schedulePlayers'>
						<thead>
							<tr>
								<th>Date/Time</th>
								<th>Division</th>
								<th>Visitor/Home</th>
								<th></th>
								{auth.isLoggedIn && <th></th>}
								<th>Winner</th>
								<th>Score</th>
							</tr>
						</thead>
						<tbody>
							{allVenueGamesAndEvents.map((game, key) => {
								return (
									<tr key={game._id || key}>
										<td>
											{game.dayOfWeek}
											{', '}
											{game.date.substr(0, 2) === '01' &&
												'Jan. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '02' &&
												'Feb. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '03' &&
												'Mar. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '04' &&
												'Apr. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '05' &&
												'May ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '06' &&
												'June ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '07' &&
												'July ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '08' &&
												'Aug. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '09' &&
												'Sept. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '10' &&
												'Oct. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '11' &&
												'Nov. ' + game.date.substr(3, 2)}
											{game.date.substr(0, 2) === '12' &&
												'Dec. ' + game.date.substr(3, 2)}
											<br></br>
											{game.time.substr(0, 2) === '00' &&
												'12:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '01' &&
												'1:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '02' &&
												'2:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '03' &&
												'3:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '04' &&
												'4:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '05' &&
												'5:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '06' &&
												'6:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '07' &&
												'7:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '08' &&
												'8:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '09' &&
												'9:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '10' &&
												'10:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '11' &&
												'11:' + game.time.substr(3, 2) + ' am'}
											{game.time.substr(0, 2) === '12' &&
												'12:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '13' &&
												'1:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '14' &&
												'2:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '15' &&
												'3:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '16' &&
												'4:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '17' &&
												'5:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '18' &&
												'6:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '19' &&
												'7:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '20' &&
												'8:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '21' &&
												'9:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '22' &&
												'10:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '23' &&
												'11:' + game.time.substr(3, 2) + ' pm'}
											{game.time.substr(0, 2) === '24' &&
												'12:' + game.time.substr(3, 2) + ' am'}
										</td>

										{!game.playoff && <td>{game.divisionName}</td>}
										{game.playoff && <td>{game.playoffDivision}</td>}

										{game.visitorTeamName && (
											<td>
												{game.visitorTeamSeed > 0 &&
													'(' + game.visitorTeamSeed + ') '}
												{game.visitorTeamName}
												{game.noPointsForVisitorTeam && ' (NP)'}
												<br></br>
												{' @ '}
												<br></br>
												{game.homeTeamSeed > 0 &&
													'(' + game.homeTeamSeed + ') '}
												{game.homeTeamName}
												{game.noPointsForHomeTeam && ' (NP)'}
												{game.description && (
													<div style={{ color: 'red', fontWeight: 'bold' }}>
														{'('}
														{game.description}
														{')'}
													</div>
												)}
											</td>
										)}

										{game.description && <td></td>}

										{game.eventName && (
											<td
												style={{
													fontWeight: 'bold',
													backgroundColor: 'pink',
												}}
											>
												{game.eventName}
											</td>
										)}

										{!game.playoff && !game.championship && <td></td>}

										{game.championship && (
											<td style={{ color: 'red', fontWeight: 'bold' }}>
												CHAMPIONSHIP GAME
											</td>
										)}

										{auth.isLoggedIn && (
											<td>
												{game.playoff &&
													game.homeTeamName &&
													game.homeTeamName !== 'TBD' &&
													game.visitorTeamName !== 'TBD' && (
														<NavLink
															className='navlinks'
															to={`/admin/playoffGameResults/${game._id}`}
															exact
														>
															Results
														</NavLink>
													)}

												{game.championship &&
													game.homeTeamName &&
													game.homeTeamName !== 'TBD' &&
													game.visitorTeamName !== 'TBD' && (
														<NavLink
															className='navlinks'
															to={`/admin/championshipGameResults/${game._id}`}
															exact
														>
															Results
														</NavLink>
													)}

												{!game.playoff &&
													!game.championship &&
													game.homeTeamName &&
													game.homeTeamName !== 'TBD' &&
													game.visitorTeamName !== 'TBD' && (
														<NavLink
															className='navlinks'
															to={`/admin/gameResults/${game._id}`}
															exact
														>
															Results
														</NavLink>
													)}

												{game.playoff &&
													!game.championship &&
													game.homeTeamName &&
													(game.homeTeamName === 'TBD' ||
														game.visitorTeamName === 'TBD') && (
														<NavLink
															className='navlinksEnterTeams'
															to={`/admin/updateGame/${game._id}`}
															exact
														>
															TEAMS
														</NavLink>
													)}
											</td>
										)}

										{game.homeTeamId && game.winner === game.homeTeamId && (
											<td>{game.homeTeamName}</td>
										)}

										{game.visitorTeamId &&
											game.winner === game.visitorTeamId && (
												<td>{game.visitorTeamName}</td>
											)}

										{game.status &&
											game.status !== 'TBP' &&
											game.winner !== game.homeTeamId &&
											game.winner !== game.visitorTeamId && <td>TIE</td>}

										{!game.score && <td></td>}

										<td
											style={{
												textDecoration: 'none',
												fontWeight: 600,
												color: 'black',
											}}
										>
											{game.score}
											{game.OTLHomeIsChecked && ' (OT)'}
											{game.OTLVisitorIsChecked && ' (OT)'}
										</td>
									</tr>
								)
							})}
						</tbody>
					</table>
				)}

				{isMobile && (
					<div style={{ textAlign: 'center', margin: '1rem 0 2rem' }}>
						<button
							className='backToTopLink'
							onClick={() =>
								window.scrollTo({
									top: 0,
									behavior: 'smooth',
								})
							}
						>
							↑ Back to Top
						</button>
					</div>
				)}
			</div>,
		)
	}

	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<SchedulesHomeNavigation />
				<div style={{ marginTop: '5rem' }}>
					<SearchByLeagueOrVenue />
				</div>
				{dateBlock && dateBlock}
				<Footer />
			</React.Fragment>
		</div>
	)
}

export default VenueSchedule
